"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _alignmentTypes = _interopRequireDefault(require("../../../../constants/alignmentTypes"));

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

var _iconNames = _interopRequireDefault(require("../../../../constants/iconNames"));

var _ImageCard = require("./ImageCard.styles");

var _construction = _interopRequireDefault(require("../../../../styles/images/cards/construction.jpg"));

var _meeting = _interopRequireDefault(require("../../../../styles/images/cards/meeting.jpg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var imageMap = {
  0: {
    alt: 'Construction Workers',
    src: _construction.default
  },
  1: {
    alt: 'Office Meeting',
    src: _meeting.default
  }
};

var ImageCard = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ImageCard, _React$PureComponent);

  var _super = _createSuper(ImageCard);

  function ImageCard() {
    _classCallCheck(this, ImageCard);

    return _super.apply(this, arguments);
  }

  _createClass(ImageCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          altText = _this$props.altText,
          className = _this$props.className,
          children = _this$props.children,
          dataTestId = _this$props.dataTestId,
          iconName = _this$props.iconName,
          imageId = _this$props.imageId,
          imageUrl = _this$props.imageUrl,
          onClick = _this$props.onClick,
          textAlign = _this$props.textAlign;
      var img = imageUrl ? {
        src: imageUrl,
        alt: altText
      } : imageMap[+imageId];
      return /*#__PURE__*/_react.default.createElement(_ImageCard.StyledCard, {
        className: className,
        colorTheme: "primaryPseudo",
        "data-test-id": dataTestId,
        noBorder: true,
        onClick: onClick,
        textAlign: textAlign,
        withShadow: true
      }, /*#__PURE__*/_react.default.createElement(_ImageCard.StyledCardHeader, {
        dataTestId: "".concat(dataTestId, "-header"),
        fullWidth: true
      }, /*#__PURE__*/_react.default.createElement(_ImageCard.StyledImage, {
        src: img.src,
        alt: img.alt,
        width: "250px",
        height: "115px"
      })), /*#__PURE__*/_react.default.createElement(_ImageCard.StyledCardBody, {
        dataTestId: "".concat(dataTestId, "-content"),
        hasTitle: false,
        textAlign: textAlign
      }, /*#__PURE__*/_react.default.createElement(_ImageCard.ContentWrapper, null, iconName && /*#__PURE__*/_react.default.createElement(_ImageCard.StyledIcon, {
        dataTestId: "image-card-content-icon",
        iconName: iconName
      }), /*#__PURE__*/_react.default.createElement(_ImageCard.TextWrapper, null, Array.isArray(children) ? children.map(function (child, idx) {
        return /*#__PURE__*/_react.default.createElement(_ImageCard.StyledText, {
          key: idx
        }, child);
      }) :
      /*#__PURE__*/
      // eslint-disable-line react/no-array-index-key
      _react.default.createElement(_ImageCard.StyledText, null, children)))));
    }
  }]);

  return ImageCard;
}(_react.default.PureComponent);

_defineProperty(ImageCard, "propTypes", {
  /** Alt text - should be provided when a custom image is used */
  altText: _propTypes.default.string,

  /** Hook for overriding top-level component styles */
  children: _propTypes2.default.children.isRequired,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** icon to display with text */
  iconName: _propTypes.default.oneOf(_iconNames.default),

  /** image id to use - just a number, 0-2 */
  imageId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /** Will override the imageId if used.
   * Only use if you need to override images that are baked in */
  imageUrl: _propTypes.default.string,

  /** alignment of header and content */
  textAlign: _propTypes.default.oneOf(_alignmentTypes.default),
  // EVENT HANDLERS

  /** onClick handler */
  onClick: _propTypes.default.func.isRequired
});

_defineProperty(ImageCard, "defaultProps", {
  altText: 'Custom Image',
  className: '',
  iconName: undefined,
  imageId: 0,
  imageUrl: undefined,
  textAlign: 'center'
});

var _default = ImageCard;
exports.default = _default;